class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.inner = this.querySelector('.c-comparison-slider__inner');
    this.handle = this.querySelector('.c-comparison-slider__handle');
    
    this.isDragging = false;
    
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp   = this.onPointerUp.bind(this);
  }

  connectedCallback() {
    if (!this.inner) return;

    this.style.setProperty('--slider-pos', '0%');

    if (this.handle) {
      this.handle.addEventListener('pointerdown', this.onPointerDown);
    }

    this._revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._revealToCenter();
          this._revealObserver.disconnect();
        }
      });
    }, { threshold: 0.2 });

    this._revealObserver.observe(this);

    const textObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cs__animate--visible');
          textObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    textObserver.observe(this.inner);

    const wrapper = this.closest('.cs');
    if (wrapper) {
      const animElements = wrapper.querySelectorAll('.cs__animate');
      animElements.forEach(el => textObserver.observe(el));
    }
  }

  disconnectedCallback() {
    if (!this.inner) return;
    if (this.handle) this.handle.removeEventListener('pointerdown', this.onPointerDown);
    if (this._revealObserver) this._revealObserver.disconnect();
  }

  _revealToCenter() {
    if (typeof gsap !== 'undefined') {
      gsap.fromTo(this, 
        { '--slider-pos': '0%' },
        { '--slider-pos': '50%', duration: 1.8, ease: 'power2.inOut' }
      );
    } else {
      this.style.transition = '--slider-pos 1.8s ease-in-out';
      this.style.setProperty('--slider-pos', '50%');
      setTimeout(() => {
        this.style.transition = '';
      }, 1900);
    }
  }

  onPointerDown(e) {
    if (typeof gsap !== 'undefined') {
      gsap.killTweensOf(this, '--slider-pos');
    }
    this.style.transition = '';

    this.isDragging = true;
    this.updateSliderPosition(e);
    
    document.addEventListener('pointermove', this.onPointerMove);
    document.addEventListener('pointerup', this.onPointerUp);
    document.addEventListener('pointercancel', this.onPointerUp);
    
    e.preventDefault(); 
  }

  onPointerMove(e) {
    if (!this.isDragging) return;
    this.updateSliderPosition(e);
    e.preventDefault();
  }

  onPointerUp(e) {
    if (!this.isDragging) return;
    this.isDragging = false;
    document.removeEventListener('pointermove', this.onPointerMove);
    document.removeEventListener('pointerup', this.onPointerUp);
    document.removeEventListener('pointercancel', this.onPointerUp);
  }

  updateSliderPosition(e) {
    const rect = this.inner.getBoundingClientRect();
    let pos = (e.clientX - rect.left) / rect.width;
    pos = Math.max(0, Math.min(1, pos));
    this.style.setProperty('--slider-pos', `${pos * 100}%`);
  }
}

if (!customElements.get('comparison-slider')) {
  customElements.define('comparison-slider', ComparisonSlider);
}